module.exports = __webpack_public_path__ + "img/settings-cog-userprofile.a7a76003.svg";